module.exports = __webpack_public_path__ + "img/luntanA_11.0cb5bef5.jpg";